import { makeStyles } from "@material-ui/core/styles";

export const policiesStyles = makeStyles((theme) => ({
  navBar: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(35, 86, 147, 1)",
  },
  container: {
    background: `url("/fruition-icon-background.svg") repeat center center fixed;`,
    height: "100%",
    minHeight: "100VH",
  },
  logo: {
    maxWidth: "250px",
  },
  paper: {
    width: "100%",
    height: "100%",
    padding: theme.spacing(8),
  },
}));
